import { z } from 'zod';
import { CardNetwork } from '@/constructs/CardNetwork';
import { MoneySchema } from '../../Money/schemas';
import type { IPaymentSummary } from './IPaymentSummary';
import { PaymentSummaryType } from './PaymentSummaryType';

/** Zod schema for {@link IPaymentSummary}. */
export const PaymentSummarySchema = z.object({
  paymentMethod: z.nativeEnum(PaymentSummaryType),
  endingDigits: z.string().optional(),
  expirationDate: z.string().optional(),
  cardNetwork: z.nativeEnum(CardNetwork).optional(),
  email: z.string().optional(),
  amount: MoneySchema.optional()
}) satisfies z.ZodType<IPaymentSummary>;
